import React, { Component } from 'react';
import {
    Container,
    Grid,
    Segment
} from 'semantic-ui-react';
import {connect} from 'react-redux';
import qs from 'query-string';
import _ from 'underscore';

import ProfileMenu from '../../component/profile/profile_menu';
import ProfileBio from '../../component/profile/profile_bio';
import ProfileBioUpdate from '../../component/profile/profile_bio_update';
import ProfileWallet from '../../component/profile/profile_wallet';
import ProfileNotifications from '../../component/profile/profile_notifications';
import CustomModal from '../../utils/CustomModal';
import FormsInputPassword from "../../component/forms/inputs/password/forms_inputs_password";
import {
    getUserProfile,
    getUserProfilePhoto2,
    submitProfileNewProfilePhoto,
    updateProfileUserProfileChangeNameAndNRIC,
    updateUserProfileGenerateChangeEmailOTP,
    updateUserProfileVerifyChangeEmailOTP,
    updateProfileUserProfileInformation,
    updateUserProfileChangePassword,
    getUserProfileBenefitPlan,
    getUserProfileBenefitConfig,
    getClaimOptionsProfile,
    getAppConfigCountryCodes,
    getProfileConfigBenefit,
    getUserProfileNotifications,
    verifyPassword
} from '../../actions';


class ProfilePage extends Component {
    constructor(props) {
      super(props);
      this.state = {
          mode: 1,
      }
      this.isAllowRefreshNotification = 0;
  }
    componentDidMount() {
       this.fetchUserProfile();
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.fetchUserProfile();
        }
    }

    fetchUserProfile(){
        const {search} = this.props.location;
        const parsedQueryString = qs.parse(search);
        if(this.isAllowRefreshNotification == 0 && this.state.mode == 1 && parsedQueryString.show === 'notifications'){
          console.log("inside here")
          this.isAllowRefreshNotification = 1;
        }else{
            this.isAllowRefreshNotification = 2;
        }
        if (this.isAllowRefreshNotification !== 1) {
            this.props.getClaimOptionsProfile(this.props.user.accessToken, this.props.user.companyId); // for bank details
            this.props.getUserProfile(this.props.user.accessToken, this.props.user.uuid);
            this.props.getUserProfilePhoto2(this.props.user.accessToken, this.props.user.uuid);
            this.props.getProfileConfigBenefit({accessToken: this.props.user.accessToken, companyId:this.props.user.companyId});
            this.props.getUserProfileBenefitPlan({accessToken: this.props.user.accessToken, userId: this.props.user.uuid, companyId:this.props.user.companyId});
            console.log("check profile picture", this.props.profilePhoto)
        }
        
        this.props.getAppConfigCountryCodes()
        if (search) {
            if (parsedQueryString.show === 'notifications') { 
                this.setState({ mode: 4 }); 
            }
            else if (parsedQueryString.show === 'updatebio') {
                this.setState({mode: 2});
            }
            else if (parsedQueryString.show === 'wallet') {
                this.setState({mode: 3});
            }
        }
    }

    handleMenuClick(e,data) {
        const nameToMode = {'Bio' : 1, 'Update Bio': 2, 'Wallet': 3, 'Notifications': 4};

        // Remove hash (anchor) if exist in url
        if(this.props.history.location.hash){
            let urlWithoutAnchor = this.props.history.location.pathname.split('#');
            this.props.history.replace(urlWithoutAnchor[0]);
        }

        console.log("check on press handle menu click", this.isAllowRefreshNotification)
        if (this.isAllowRefreshNotification == 1) {
            this.isAllowRefreshNotification = 2
            this.fetchUserProfile();
        }

        this.setState({mode: nameToMode[data.name]});
    }
    render() {
        //console.log("TESTING");
        //console.log(this.props);
        var sortedUserNotifications = _.sortBy(this.props.userNotifications, function(o) {
            var dt = new Date(o.created);
            return -dt;
        })

        return (
            <Container fluid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <ProfileMenu
                                activeItem={this.state.mode}
                                handleMenuClick={this.handleMenuClick.bind(this)}
                            />
                            <Segment attached>
                                {
                                    (this.state.mode === 1) ?
                                    (
                                        <ProfileBio
                                            user={this.props.user}
                                            profilePhoto={this.props.profilePhoto}
                                            benefitPlans={this.props.benefitPlans}
                                            isnotificationOtp={this.isAllowRefreshNotification}
                                            benefits={this.props.benefits}
                                            getUserBenefitPlan={this.props.getUserProfileBenefitPlan}
                                            getUserBenefitConfig={this.props.getUserProfileBenefitConfig}
                                            getUserPlanConfigBenefit={this.props.getProfileConfigBenefit}
                                        />
                                    )
                                    :
                                    null
                                }
                                {
                                    (this.state.mode === 2) ?
                                    (
                                        <ProfileBioUpdate
                                            user={this.props.user}
                                            claimOptions={this.props.claimOptions}
                                            countryCodeOptions={this.props.countryCodeOptions}
                                            profilePhoto={this.props.profilePhoto}
                                            submitNewProfilePhoto={this.props.submitProfileNewProfilePhoto}
                                            getUserProfilePhoto={this.props.getUserProfilePhoto2}
                                            configBenefit={ this.props.configBenefit } 
                                            verifyPasswordAction={this.props.verifyPassword}
                                            updateUserProfileInformation={this.props.updateProfileUserProfileInformation}
                                            updateUserProfileChangeNameAndNRIC={this.props.updateProfileUserProfileChangeNameAndNRIC}
                                            updateUserProfileGenerateChangeEmailOTP={this.props.updateUserProfileGenerateChangeEmailOTP}
                                            updateUserProfileVerifyChangeEmailOTP={this.props.updateUserProfileVerifyChangeEmailOTP}
                                            updateUserProfileChangePassword={this.props.updateUserProfileChangePassword}
                                        />
                                    )
                                    :
                                    null
                                }
                                {
                                    (this.state.mode === 3) ?
                                    (
                                        <ProfileWallet
                                            user={this.props.user}
                                            profilePhoto={this.props.profilePhoto}
                                        />
                                    )
                                    :
                                    null
                                }
                                {
                                    (this.state.mode === 4) ?
                                    (
                                        <ProfileNotifications
                                            user={this.props.user}
                                            profilePhoto={this.props.profilePhoto}
                                            notifications={sortedUserNotifications}
                                            notificationStatus={this.props.notificationStatus}
                                            checkAvailableNotification={this.props.getUserProfileNotifications}
                                        />
                                    )
                                    :
                                    null
                                }
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        profilePhoto: state.user.profilePhoto,
        userNotifications: state.user.notifications,
        configBenefit: state.user.configBenefit,
        benefitPlans: state.user.benefitPlans,
        benefits: state.user.benefits,
        claimOptions: state.claimOptions,
        countryCodeOptions: state.appConfig.countryCodes,
        contactNoVerified: state.otp.contactNoVerified,
        notificationStatus: state.notificationStatus,
    }
}

export default connect(mapStateToProps,{
    getUserProfilePhoto2,
    submitProfileNewProfilePhoto,
    updateProfileUserProfileInformation,
    updateProfileUserProfileChangeNameAndNRIC,
    updateUserProfileGenerateChangeEmailOTP,
    updateUserProfileVerifyChangeEmailOTP,
    updateUserProfileChangePassword,
    getUserProfileBenefitPlan,
    getUserProfileBenefitConfig,
    getClaimOptionsProfile,
    getAppConfigCountryCodes,
    getUserProfile,
    getUserProfileNotifications,
    getProfileConfigBenefit,
    verifyPassword
})(ProfilePage);
